/** Echappe le texte pour une insertion sure dans du contenu HTML (innerHTML). */
export function escapeHtml(text: string): string {
  return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

/** Idem, plus les guillemets : pour une insertion sure a l'interieur d'un attribut `"..."`. */
export function escapeHtmlAttribute(text: string): string {
  return escapeHtml(text).replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}
